/* bsd-pdp-051.js · BSD-051 · 13 Oct 2026
   Small buy-box changes on top of hearth-parent.js, which is NOT changed.
   Same pattern as hearth-parent-cut.js: watch what hearth-parent.js renders,
   then add to it. Wording comes from #bsd51-config (theme editor settings of
   the "BSD-051 page parts" section). Turn it all off there.

   1. Outcome line under the product name.
   2. Stars + "4.84/5 · 694 reviews" become one link to #reviews.
   3. Grade line: the Premium sentence shown in bold.
   4. One delivery card replaces the delivery dropdown, the breakdown and the
      arrival box (those stay in the page, hidden, so hearth-parent.js runs
      exactly as before with delivery left on "collect"). The card's dates are
      read from the hidden arrival box, so they always match hearth-parent.js
      (working days, bank holidays, sealing day, sold out).
   5. Two lines with icons under the Add to basket button: crack guarantee,
      and photo of your slab (13 Oct 23:4x, Ravi). The photo line says
      "included" when Premium or a finish (sealing / Signature) is chosen,
      otherwise how to get it. Its "See how it works" link is only added when
      the section found the blog post published (cfg.photoLink).
   6. The hidden "_delivery" basket line property is no longer sent: with the
      dropdown gone it would always say "Collection" on delivered orders.
      Checkout's shipping line is the real delivery record (BSD-043). */
(function () {
  var cfgEl = document.getElementById('bsd51-config');
  var hpCfgEl = document.getElementById('hp-config');
  if (!cfgEl || !hpCfgEl) return;
  var cfg = {}, hp = {}, bands = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  try { hp = JSON.parse(hpCfgEl.textContent); } catch (e) { hp = {}; }
  try { bands = JSON.parse(document.getElementById('hp-bands').textContent); } catch (e) { bands = {}; }
  function $(id) { return document.getElementById(id); }
  function money0(p) { var v = p / 100; return '£' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); }

  /* 1. Outcome line */
  var title = document.querySelector('.hp .hp__title');
  if (title && cfg.outcome && !document.querySelector('.bsd51-outcome')) {
    var o = document.createElement('p');
    o.className = 'bsd51-outcome';
    o.textContent = cfg.outcome;
    title.parentNode.insertBefore(o, title.nextSibling);
  }

  /* 2. Stars as a link */
  var sig = document.querySelector('.hp .hp__signal > b');
  if (sig && document.getElementById('reviews')) {
    var m = sig.textContent.trim().match(/^(★+)\s*(.*)$/);
    if (m) {
      var a = document.createElement('a');
      a.href = cfg.reviewsAnchor || '#reviews';
      a.className = 'bsd51-stars';
      a.innerHTML = '<span class="bsd51-stars__s" aria-hidden="true"></span><span class="bsd51-stars__t"></span>';
      a.firstChild.textContent = m[1];
      a.lastChild.textContent = m[2];
      a.setAttribute('aria-label', m[2] + ', read the reviews');
      sig.parentNode.replaceChild(a, sig);
    }
  }

  /* 3. Grade line, Premium sentence in bold */
  var grade = $('hp-say-grade');
  function boldGrade() {
    if (!grade || !cfg.gradeBold || grade.querySelector('b')) return;
    var t = grade.textContent, i = t.indexOf(cfg.gradeBold);
    if (i < 0) return;
    grade.textContent = '';
    if (i > 0) grade.appendChild(document.createTextNode(t.slice(0, i)));
    var b = document.createElement('b');
    b.style.color = 'var(--hp-ink)';
    b.textContent = cfg.gradeBold;
    grade.appendChild(b);
    var rest = t.slice(i + cfg.gradeBold.length);
    if (rest) grade.appendChild(document.createTextNode(rest));
  }

  /* 4. Delivery card */
  var arrive = $('hp-arrive');
  var card = document.createElement('div');
  card.className = 'bsd51-del';
  card.id = 'bsd51-del';
  card.hidden = true;
  card.innerHTML = '<p class="bsd51-del__h"></p><p class="bsd51-del__p"></p><p class="bsd51-del__s"></p>';
  if (arrive) arrive.parentNode.insertBefore(card, arrive.nextSibling);

  function shortRange(r) {
    /* "Thu 15 Oct – Mon 19 Oct" -> "Thu 15 – Mon 19 Oct" when the month matches */
    var mm = r.match(/^(\w+ \d+) (\w+) – (\w+ \d+) (\w+)$/);
    return (mm && mm[2] === mm[4]) ? mm[1] + ' – ' + mm[3] + ' ' + mm[4] : r;
  }
  function rateNow() {
    var vid = ($('hp-vid') || {}).value;
    var b = bands[vid];
    if (!b) return null;
    return b.band === 'oversized' ? (hp.rateOversized || 13000) : (hp.rateStandard || 7800);
  }
  function renderCard() {
    if (!arrive) return;
    var shown = arrive.style.display !== 'none' && arrive.textContent.trim() !== '';
    var t = arrive.textContent.replace(/\s+/g, ' ').trim();
    var mt = t.match(/Ready to collect (.+?)\.\s*Choose delivery and it arrives (.+?)\./);
    if (!shown || !mt) { card.hidden = true; return; }
    var rate = rateNow();
    var seal = hp.copy && hp.copy.sealDryNote && t.indexOf(hp.copy.sealDryNote) >= 0;
    card.children[0].textContent = (cfg.deliveredWord || 'Delivered') + ' ' + shortRange(mt[2]);
    var line = String(cfg.deliveryLine || '')
      .replace('[price]', rate === null ? '' : money0(rate))
      .replace('[ready]', mt[1]);
    card.children[1].innerHTML = line;
    card.children[2].textContent = (seal ? hp.copy.sealDryNote + ' ' : '') + (cfg.deliveryCheckout || '');
    card.hidden = false;
  }

  /* 5. Guarantee and photo lines under the button (inside the form, so they keep the form's place on phones) */
  var form = $('hp-form'), atc = $('hp-atc');
  var photo = null;
  if (form && !document.querySelector('.bsd51-guar')) {
    var after = (atc && atc.parentNode === form) ? atc : null;
    var addLine = function (cls, html) {
      var p = document.createElement('p');
      p.className = 'bsd51-guar ' + cls;
      var span = document.createElement('span');
      span.innerHTML = html;
      p.appendChild(span);
      if (after) form.insertBefore(p, after.nextSibling); else form.appendChild(p);
      after = p;
      return p;
    };
    if (cfg.guaranteeHtml) addLine('bsd51-guar--crack', cfg.guaranteeHtml);
    if (cfg.photoIn) photo = addLine('bsd51-guar--photo', '');
  }
  function renderPhoto() {
    if (!photo) return;
    var fin = ($('hp-fin') || {}).value || 'none';
    var gi = typeof hp.idxGrade === 'number' ? hp.idxGrade : -1;
    var gradeEl = gi >= 0 ? $('hp-opt-' + gi) : null;
    var premium = !!(gradeEl && /premium/i.test(gradeEl.value || ''));
    var html = (premium || fin !== 'none') ? cfg.photoIn : (gradeEl ? cfg.photoOut : (cfg.photoOutNoGrade || cfg.photoOut));
    if (!html) { photo.hidden = true; return; }
    if (cfg.photoLink) html += ' <a href="' + cfg.photoLink + '">' + (cfg.photoLinkText || 'See how it works ➔') + '</a>';
    if (photo.__html !== html) { photo.firstChild.innerHTML = html; photo.__html = html; }
    photo.hidden = false;
  }

  /* 6. Drop the hidden _delivery property on basket adds from this page */
  if (window.fetch && !window.__bsd51fetch) {
    window.__bsd51fetch = true;
    var orig = window.fetch;
    window.fetch = function (url, opts) {
      try {
        if (typeof url === 'string' && /\/cart\/add\.js/.test(url) && opts && typeof opts.body === 'string') {
          var body = JSON.parse(opts.body);
          if (body && body.items) {
            body.items.forEach(function (it) { if (it.properties) delete it.properties._delivery; });
            opts = Object.assign({}, opts, { body: JSON.stringify(body) });
          }
        }
      } catch (e) { /* send unchanged */ }
      return orig.call(this, url, opts);
    };
  }

  function run() { boldGrade(); renderCard(); renderPhoto(); }
  if (window.MutationObserver) {
    if (arrive) new MutationObserver(renderCard).observe(arrive, { childList: true, attributes: true, attributeFilter: ['style'] });
    if (grade) new MutationObserver(boldGrade).observe(grade, { childList: true });
  }
  document.addEventListener('change', function () { setTimeout(run, 0); });
  run();
})();
